import React from 'react';
import { useParams } from 'react-router';

import { MOBILE_BREAK_POINT } from 'app/constants';
import useIsMobile from 'hooks/use-is-mobile';
import formatDate from 'utils/format-date';

import MarkdownContent from './components/MarkdownContent';
import Navigation from './components/Navigation';
import Summaries from './components/Summaries';
import Toc from './components/Toc';
import useChangelogData from './hooks/use-changelog-data';
import useStyles from './styles';

import Layout from '../components/Layout';

const ChangelogDetails: React.FC = () => {
    const { classes } = useStyles();
    const isMobile = useIsMobile(MOBILE_BREAK_POINT);
    const { id } = useParams<{ id: string }>();
    const data = useChangelogData(id);

    return (
        <Layout>
            {data ? (
                <div className={classes.root}>
                    {isMobile ? null : <Summaries id={id} summaries={data.summaries} className={classes.summaries} />}
                    <main className={classes.main}>
                        <div className={classes.date}>{formatDate(data.summary.current.date, 'MMMM d, yyyy')}</div>
                        <hr className={classes.divider} />
                        <MarkdownContent content={data.full.body} />
                        <hr className={classes.divider} />
                        <Navigation prevSummary={data.summary.previous} nextSummary={data.summary.next} />
                    </main>
                    <Toc body={data.full.body} collapsible={isMobile} className={classes.toc} />
                </div>
            ) : null}
        </Layout>
    );
};

export default ChangelogDetails;
